import { getSubdomain } from './api'

export const getStoreKey = (storeID: string): string => {
  const clientSubdomain = getSubdomain()
  return `${storeID}-${clientSubdomain || 'default'}`
}
